import Repository from "@/api/repository";
import { featureKeysEndpoints } from "./featureKeysEndpoints";
export const featureKeysRepository = {
    activateFeature(model) {
        return Repository.post(featureKeysEndpoints.activateFeature, model);
    }
};
